<script>
import baseMixin from '@/mixins/baseMixin'
import VuetifyTextClass from '@/shared/constants/core/VuetifyTextClass'

export default {
  name: 'BasePageTitle',
  mixins: [baseMixin],
  props: {
    title: {
      type: String,
      default: 'Page Title',
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleOnTop: {
      type: Boolean,
      default: false,
    },
    subtitleClass: {
      type: String,
      default: `${VuetifyTextClass.smallBody} mb-0 opacity-7`,
    },
    backButton: {
      type: Boolean,
    },
  },
}
</script>

<template>
  <section
    :class="[isMobileViewPort ? 'mb-4' : 'mb-8', 'd-flex align-center mt-3']"
  >
    <slot name="leftAction"> </slot>
    <header>
      <h4 v-if="subtitleOnTop" id="page-subtitle" :class="subtitleClass">
        {{ subtitle }}
      </h4>
      <slot name="title">
        <h2
          id="page-title"
          :class="[
            !isMobileViewPort ? `${textClass.h5} d-inline-block` : textClass.h6,
            subtitleOnTop ? 'mt-0 mb-8' : 'mb-0',
          ]"
        >
          {{ title }}
        </h2>
        <slot name="appendTitle"></slot>
      </slot>
      <slot name="bottomSubtitle">
        <h4 v-if="!subtitleOnTop" id="page-subtitle" :class="subtitleClass">
          {{ subtitle }}
        </h4>
      </slot>
    </header>
  </section>
</template>
